import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IEditingModelInfo, IExecuteModelScriptInfo, IImportModelTagsInfo, IModelInfo, IUploadModelInfo } from "../../entities/nu-model-info";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { Clipboard } from "../../scripts/ah.mb.clipboard";
import { DefaultLinkRules } from "../../scripts/ah.mb.default-link-rules";
import { LinkValidator } from "../../scripts/ah.mb.link-validator";
import { ApiServices } from "../../scripts/ah.mb.model-command-log-services";
import { ModelTree } from "../../scripts/ah.mb.model-tree";
import { StringUtils } from "../../scripts/ah.mb.model-utils";
import { DirectoryServices } from "../../scripts/ah.mb.ui.directory-services";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelUtils } from "../../scripts/ah.mb.ui.model-utils";
import { MethodDelayer } from "../../scripts/common/ah.mb.common.method-delayer";
import { INodeObject, NodeObject } from "../../scripts/common/ah.mb.common.node-object";
import { ModelNotifier } from "../../scripts/model-notifier";
import { DefaultModelActionsHandler } from "../../scripts/model-notifier/ah.mb.common.default-model-actions-handler";
import { NodeCopyPasteData } from "../../scripts/model-notifier/ah.mb.ui.model-observer";
import { IPasteNodesOptions } from "../paste-nodes-options-dialog/paste-nodes-options-dialog";
import { MessageBox } from "uiv";

@Component
export default class ModelDirectory extends Vue {

    // Initial tree lazy mode
    private modelTreeIsLazy = true;

    // Model tree instance
    private modelTree: ModelTree = null;

    // Model tree clipboard
    private clipboard = new Clipboard();

    // Model change observer
    private modelObserver = new ModelNotifier();

    // Create user notifier
    private userNotifier = new ClientNotifier();

    // Create modelServices
    modelServices = new modelServices(this.modelObserver);

    // Directory services
    private directoryServices = new DirectoryServices(this.modelObserver);

    //// Model observer for handling deletions etc
    //private modeDirectoryModelObserver: IModelObserver = new ModelDirectoryModelObserver(
    //    this.handleNodesDeleted);

    // Client side model logic
    // Awkward composition here
    private linkRules = DefaultLinkRules.getRules();
    private linkValidation = new LinkValidator(this.linkRules);
    private modelValidation = new ModelUtils(this.linkValidation);

    // ModelId (this is the directory tree model)
    static readonly modelId = "_DirectoryTree";

    // Model actions handler
    private modelActionsHandler = new DefaultModelActionsHandler(
        ModelDirectory.modelId,
        this.modelServices,
        this.userNotifier,
        this.clipboard);

    // Command log services
    private commandLogServices = new ApiServices();

    private selectedNodeInfo: IModelInfo = null;

    private showCreateNewModelDialog = false;
    private newModelInfo: IModelInfo = null;

    private showUploadModelDialog = false;
    private uploadModelInfo: IUploadModelInfo = null;

    private showModelPropertiesDialog = false;
    private editingModelProperties: IEditingModelInfo = null;

    private showImportModelTagsDialog = false;
    private importModelTagsModelInfo: IImportModelTagsInfo = null;

    private showExecuteScriptDialog = false;
    private executeModelScriptInfo: IExecuteModelScriptInfo = null;

    private showAutoTagModelDialog: boolean = false;
    private modelToAutoTagId: string = "";

    private showConvergeModelDialog: boolean = false;
    modelToConvergeId: string = "";

    private showDownloadModelDialog = false;
    private downloadModelInfo: IModelInfo = null;

    private showPasteNodesOptionsDialog = false;
    private pasteNodesOptions: IPasteNodesOptions = null;

    private modelTreeFilter = "";


    data() {

        return {
            selectedNodeInfo: this.selectedNodeInfo,
            showCreateNewModelDialog: this.showCreateNewModelDialog,
            newModelInfo: this.newModelInfo,
            uploadModelInfo: this.uploadModelInfo,
            showUploadModelDialog: this.showUploadModelDialog,
            editingModelProperties: this.editingModelProperties,
            showImportModelTagsDialog: this.showImportModelTagsDialog,
            importModelTagsModelInfo: this.importModelTagsModelInfo,
            showExecuteScriptDialog: this.showExecuteScriptDialog,
            executeModelScriptInfo: this.executeModelScriptInfo

        }
    }


    // Document ready handler
    mounted() {

        // Todo: Fix tooltips (try using uiv)
        //$('[data-toggle="tooltip"]').tooltip({
        //        'delay': { show: 500, hide: 500 }
        //    });        

        document.addEventListener("paste", this.documentPasteHandler);

        // The paste button is only needed for IE
        // Todo: Verify cast works
        var anyWindow = window as any;
        if (!(anyWindow.clipboardData))
            $("#pasteButton").hide();
        $("#pasteButton").hide();

        // Node editor options
        const editorOptions = {
            tableContainer: $("#nodeDataEditorTableDiv"),
            responseDiv: $("#nodeDataEditorResponseDiv"),
            variableTreeDiv: $("#nodeDataEditorVariableTreeDiv"),
            cancelButton: $("#nodeDataEditorCancelButton"),
            saveButton: $("#nodeDataEditorSaveButton"),
            closeButton: $()
        };

        // Populate model tree
        this.populateTree();

        //        this.setControlSizes();
    };

    pasteButtonClick() {
        /* IE only fucking bs to fix non-pasting to tree problem */
        var anyWindow = window as any;
        var clipboarddata = anyWindow.clipboardData.getData("Text");
        this.pasteNodesFromClipboard(clipboarddata);
    }


    beforeRouteLeave(to, from, next) {

        // Todo: Make sure this is called

        //Save selected node, so it can be shown again when we return to this
        //page as a convenience to the user
        const activeNode = this.modelTree.getActiveNode();
        if (activeNode)
            localStorage.setItem("modelTree_ActiveNode", activeNode.pathAndName);

        // Detatch paste handler so it doesn't get fired after we have left this page
        document.removeEventListener("paste", this.documentPasteHandler);

        next();

    }

    onCopyButtonClick() {
        this.modelTree.copySelectedTreeNodes(false);

    }

    getNodesUrlFunc(modelId, nodePathAndName) {

        nodePathAndName = encodeURIComponent(nodePathAndName);

        let url = `/api/1.0/modeltree?modelId=${modelId}&rootNode=${nodePathAndName}&lazy=${this.modelTreeIsLazy}&filter=${this.modelTreeFilter}`;

        url = encodeURI(url);
        return url;
    }

    /* Set element sizes for ones where we can't get the fuckin css to do it for us
       This is called on resize, and also after adminlte sidebar collapse/expand */
    setControlSizes() {

        const parent = $(".content-wrapper");

        const tree = $("#treeDiv");
        const footer = $("footer");

        const buttonsRow = $("#buttonsDiv");

        const mainHeader = $(".main-header");
        //var header = $(".content-header"); // Not currently visible

        const margins = 12;

        const windowHeight = window.window.innerHeight;

        const treeHeight = windowHeight -
            footer.outerHeight() -
            buttonsRow.outerHeight() -
            //header.outerHeight() - 
            24 -
            mainHeader.outerHeight();

        //console.clear();
        //console.log('windowHeight', windowHeight);

        //console.log('buttonsRow.height()', buttonsRow.height());
        //console.log('$(window).height()', $(window).height());
        //console.log('footer.outerHeight()', footer.outerHeight());

        //console.log('parent.outerHeight()', parent.outerHeight());
        //console.log('parent.height()', parent.height());
        //console.log('mainHeader.outerHeight', mainHeader.outerHeight());
        //console.log('header.outerHeight()', header.outerHeight());
        //console.log('buttonsRow.outerHeight()', buttonsRow.outerHeight());

        //console.log('treeHeight', treeHeight);


        const viewDiv = $("#viewDiv");

        //console.log('*** WIDTHS ***');
        //console.log('parent.outerWidth()', parent.outerWidth());
        //console.log('viewDiv.outerWidth()', viewDiv.outerWidth());

        tree.height(treeHeight - (margins));
        tree.width(parent.outerWidth() - viewDiv.outerWidth() - (margins));
    }

    // Populate tree function
    populateTree() {

        // Create a root tree node
        const rootTreeNode = {
            title: "Models",
            key: "\\Models",
            lazy: true,
            extraClasses: "directoryfolder-node fancytree-has-children",
            folder: true,
            nodeType: "Root"
        };

        const loadPromise = $.Deferred();

        this.modelTree = new ModelTree($("#treeDiv"),
            this.getNodesUrlFunc,
            ModelDirectory.modelId,
            rootTreeNode,
            this.treeSelectionChanged,
            this.modelActionsHandler,
            () => { return false }, //treeNodeIconClicked,
            this.modelValidation);

        // Expand root node
        this.modelTree.expandRootNode().then(() => {

            if (this.modelTreeFilter) {
                const rootNode = this.modelTree.tree.getActiveNode();
                rootNode.setTitle(`Search results for ${this.modelTreeFilter} (${this.modelTree.tree.getActiveNode().children.length} nodes)`);
                rootNode.removeClass("directoryfolder-node");
                rootNode.addClass("search-results-node");

            }
            else {
                var savedNode = localStorage.getItem("modelTree_ActiveNode");
                if (savedNode)
                    this.modelTree.expandToNode(savedNode)
                        .then(() => {
                            if (this.modelTree.findNode(savedNode))
                                this.modelTree.activateNode(savedNode, false);
                            // It may have been deleted, if so just try going to parent
                            else {
                                const parent = NodeObject.extractPath(savedNode);
                                if (this.modelTree.findNode(parent))
                                    this.modelTree.activateNode(parent, false);
                            }
                        });
            }

        }).then(() => {
            // For convenience, always open pinned folder
            this.modelTree.expandNode("\\Models\\Pinned", true);
        });


        // Attach to model observer
        this.modelObserver.attach(this.modelTree);

        // Model observer to refresh recycle bin
        // Disabled for now because refreshing the bin causes it's node to get the focus
        //this.modelObserver.attach(this.modeDirectoryModelObserver);

        loadPromise.done(() => {
        });
    }

    // Handler for tree selection change
    treeSelectionChanged(nodes) {

        if (nodes.length < 1 || nodes.length > 2)
            return;

        const node = nodes[0];

        // Change of region - if pending changes, prompt user to save
        // promptToSaveChanges(node.data.title);

        // Get the full selected node path and name
        const nodePath = node.pathAndName;

        // A DynaTreeNode object is passed to the activation handler
        // Note: we also get this event, if persistence is on, and the page is reloaded.

        // Refresh charts, if chart tab is active

        //var activeTab = $('li.active')[0].id;
        //viewTabChanged(activeTab);

        //if ($('#chartTabLi').hasClass("active"))
        //    doRefreshNodeViews(nodePath);

        //var headerText = "";
        //if (node) {
        //    headerText = nodePath; //.data.title;
        //} else
        //headerText = headerText + ": (no node selected)";

        // Show path in title
        //var $link = $("#diagramHeader");
        //$link.html(headerText);

        this.updateModelTreeActions(nodePath, node.nodeType);

        this.refreshNodeView(node);


    }

    // Refreshes the current node view
    refreshActiveNodeView() {
        const selNode = this.modelTree.getActiveNode();
        if (selNode) {
            var origNode = selNode.pathAndName;
            const folder = this.getNearestTreeFolderPath();
            const node = this.modelTree.findNode(folder);
            this.modelTree.refreshNodeChildren(node.pathAndName).then(() => {
                // Todo: verify this
                this.modelTree.activateNode(origNode, false);
            });
        } else
            this.selectedNodeInfo = null;
        //            $("#activeNodeDiv").empty();

    }

    refreshNodeView(node: INodeObject) {

        if (node && node.nodeType == "DirectoryModel") {

            // Load view for node into the tree
            const url = `/modeldirectory/modelinfo?nodeName=${node.fqmId}`;

            //    '@Url.Action("GetDirectoryNodePartial", new {nodeName = "_nodepath_"})';
            //var url = rawUrl.replace("_nodepath_", node.name);

            return $.get({
                url: url,
                global: false,
                cache: false,
                success: (result) => {

                    this.selectedNodeInfo = result; //{ name: result.name };
                    this.selectedNodeInfo.path = node.path;
                    this.selectedNodeInfo.logCommands = result.commandLoggingEnabled;
                    //console.log(result);


                    // Todo: Convert this razor shit
                    var logUrl = "";

                    //logUrl = logUrl.replace("_modelId_", node.name);
                    //logUrl = encodeURI(logUrl);

                    //FetchWrapper.fetch(logUrl, { method: "get" })
                    //    .then(response => response.json())
                    //    .then((logData: string) => {
                    //        $("#modelTimeLineDiv").html(logData);
                    //    });

                }
            });
        } else {
            this.selectedNodeInfo = null
            //            $("#activeNodeDiv").empty();
            return $.Deferred().resolve().promise();
        }
    }


    // Tree nodes copied event
    treeNodesCopied(copyData) {
        this.clipboard.copyToClipboard(JSON.stringify(copyData));

        this.userNotifier.showSimpleMessage(copyData.nodeFullPaths.length.toString() + " node(s) on clipboard");
    }

    // Delete node button click
    deleteSelectionButtonClick() {
        const nodes = this.modelTree.getSelectedNodes();
        this.modelActionsHandler.deleteNodes(nodes)
            .then(() => this.refreshActiveNodeView);
    }

    // Rename sector button click handler
    renameNodeButtonClick() {
        const activeNode = this.modelTree.getActiveNode();
        if (activeNode)
            this.modelActionsHandler.renameNode(activeNode.pathAndName);
    }

    // Document paste handler
    documentPasteHandler(e) {

        if ($(e.currentTarget.activeElement).hasClass("fancytree-container") ||
            $(e.currentTarget.activeElement).hasClass("copyPaste")) {
            e.preventDefault();

            const text = (e.originalEvent || e).clipboardData.getData("text/plain");
            if (!text) {
                alert("Error getting clipboard data");
                return;
            }

            // Now paste
            this.pasteNodesFromClipboard(text);
        }
        // If we dont have the focus, let the event continue propogation
    }


    // Update model tree actions function - triggered by sector select
    updateModelTreeActions(path: string, nodeType: string) {
        // Null check
        if (!nodeType) {
            $("#createNewModelButton").addClass("disabled");
            $("#refreshModelListButton").addClass("disabled");
            $("#renameSelectionButton").addClass("disabled");

        } else {
            $("#refreshModelListButton").removeClass("disabled");
            $("#createNewModelButton").removeClass("disabled");
            $("#uploadModelButton").removeClass("disabled");
        }

        const canDelete = this.modelValidation.canDeleteNode(nodeType, false);

        $("#deleteTreeSelectionButton").toggleClass("disabled", !canDelete);
        $("#uploadModelButton").toggleClass("disabled", nodeType !== "DirectoryFolder");
        $("#createFolderButton").toggleClass("disabled", nodeType !== "DirectoryFolder");

        $("#copyButton").toggleClass("disabled", !nodeType);
        $("#pasteButton").toggleClass("disabled", !nodeType);

        // Disable crea
        $("#createNewModelButton").toggleClass("disabled", nodeType !== "DirectoryFolder");

        // Search and replace button enabled/disabled
        //$('#searchAndReplaceButton').toggleClass('disabled', !nodeType);

    };

    // Upload model click
    uploadModelButtonClick() {

        // Get the folder the node will exist in
        const nodePath = this.getNearestTreeFolderPath();

        this.uploadModelInfo = {
            fileName: "",
            name: "",
            category: "",
            description: "",
            path: nodePath,
            logCommands: false,
            isPinned: false,
            fullyQualifiedModelId: ""

        }

        this.showUploadModelDialog = true;
    }


    // Create new model button click
    createNewModelButtonClick() {

        // Get the folder the node will exist in
        const nodePath = this.getNearestTreeFolderPath();

        this.newModelInfo = {
            name: "",
            category: "",
            description: "",
            logCommands: false,
            path: nodePath,
            isPinned: false,
            fullyQualifiedModelId: ""
        }

        this.showCreateNewModelDialog = true;

    }

    createNewModelDialogAccepted(result) {

        if (result === "ok") {
            var notification = this.userNotifier.showBusyNotification("Creating model");

            this.directoryServices.createModel(this.newModelInfo.name,
                this.newModelInfo.description,
                this.newModelInfo.category,
                this.newModelInfo.logCommands,
                this.newModelInfo.path)
                .then(response => {
                    if (response.success)
                        this.showOpenModelPrompt(this.newModelInfo.name);
                })
                .then((response) => this.userNotifier.clear(notification));
        }
    }

    // Create new model button click
    createFolderButtonClick() {

        // Get the folder the node will exist in
        var nodePath = this.getNearestTreeFolderPath();

        // Show the dialog
        bootbox.prompt(
            {
                title: `New folder under ${nodePath}`,
                content: "Folder name",
                callback: (nodeName => {
                    if (nodeName)
                        this.modelActionsHandler.createNode(
                            nodePath,
                            nodeName,
                            "DirectoryFolder",
                            {});
                })
            });
    }

    //uploadModelDialogClosed(result) {
    //    if (result === "ok") {

    //        const formEl = <HTMLFormElement>document.getElementById("uploadModelForm");
    //        const formData = new FormData(formEl);


    //        var notification = this.userNotifier.showBusyNotification("Uploading model...");

    //        this.directoryServices.uploadModel(formData,
    //                this.uploadModelInfo.name,
    //                this.uploadModelInfo.description,
    //                this.uploadModelInfo.category,
    //                this.uploadModelInfo.targetPath)
    //            .then((response => this.userNotifier.clear(notification)));

    //    }
    //}


    // Gets nearest selected folder in tree (if leaf is active, select parent)
    getNearestTreeFolderPath(): string {
        let activeNode = this.modelTree.getActiveNode();
        while (activeNode.nodeType !== "DirectoryFolder")
            activeNode = this.modelTree.findNode(activeNode.path);
        return activeNode.pathAndName;
    }

    // Prompts to open a model
    showOpenModelPrompt(modelName) {
        bootbox.confirm("Open model?",
            ok => {
                if (ok) {

                    this.$router.push({ name: "model-editor", params: { modelId: modelName } });
                }

            });
    }


    onOpenModelClicked(value: IModelInfo) {

        //const link = this.$router.resolve({
        //    name: "model-viewer"
        //});


        this.$router.push({ name: "model-editor", params: { modelId: value.fullyQualifiedModelId, targetPath: "" } });

        //        this.$router.push("/modeleditor", () => alert("Complete"), () => alert("abort"));
        //this.$router.go("/modelviewer"); //{ name: "model-viewer", params: { modelId: modelId } });
        //console.log(link);
    }

    onViewModelLogClicked(value: IModelInfo) {

        //const link = this.$router.resolve({
        //    name: "model-viewer"
        //});

        var modelId = value.name;

        var treeNode = this.modelTree.findNode(value.path);
        if (treeNode && treeNode.nodeType == 'DirectoryModel') {
            // Since this the child of a model, it must be a scenario.  Combine the parent and child
            // ids to construct a scenario type modelid

            modelId = ModelUtils.buildScenarioModelId(treeNode.name, modelId);

        }
        this.$router.push({ name: "model-command-log", params: { modelId: modelId, scenarioId: "" } });
    }

    onConvergeModelClicked(value: IModelInfo) {

        this.modelToConvergeId = value.fullyQualifiedModelId;
        this.showConvergeModelDialog = true;
    }

    onModelReportsClicked(value: IModelInfo) {

        this.$router.push({ name: "model-reports", params: { modelId: value.fullyQualifiedModelId } });

        //        this.$router.push({ path: "/model-reports", params: { modelId: modelId } });
    }


    onModelUploading() {
        //this.showUploadModelDialog = false;
    }

    onModelUploaded(modelInfo: IModelInfo) {

        this.showUploadModelDialog = false;
        //// Get the folder the node will exist in
        //var nodePath = this.getNearestTreeFolderPath();
        this.showOpenModelPrompt(modelInfo.name);
        const nodeInfo = new NodeObject(modelInfo.path + "\\" + modelInfo.name, "DirectoryModelNode", false, "");
        this.modelObserver.notifyNodeCreated(nodeInfo, {});
    }

    editModelPropertiesDialogAccepted(dialogResult: string) {
        if (dialogResult === "ok") {


            var notification = this.userNotifier.showBusyNotification("Saving changes...");
            this.directoryServices.editModelProps(
                this.editingModelProperties.modelId,
                this.editingModelProperties.name,
                this.editingModelProperties.description,
                this.editingModelProperties.category,
                this.editingModelProperties.logCommands,
                this.editingModelProperties.path)
                .then(result => {
                    this.userNotifier.clear(notification);
                    if (result.success)
                        this.refreshActiveNodeView();
                });


        }
    }

    onModelPropertiesClicked(modelInfo: IModelInfo) {
        this.editingModelProperties = {
            modelId: modelInfo.name,
            name: modelInfo.name,
            description: modelInfo.description,
            category: modelInfo.category,
            logCommands: modelInfo.logCommands,
            path: modelInfo.path,
            isPinned: modelInfo.isPinned,
            fullyQualifiedModelId: modelInfo.fullyQualifiedModelId
        };

        this.showModelPropertiesDialog = true;

    }

    onValidateModelButtonClick(modelInfo: IModelInfo) {
        this.$router.push({ name: "model-validation", params: { modelId: modelInfo.fullyQualifiedModelId } });
    }


    onDownloadModelClick(modelInfo: IModelInfo) {
        this.showDownloadModelDialog = true;
        this.downloadModelInfo = modelInfo;
    }

    onUpdateSlopeCfsClick(modelInfo: IModelInfo) {

        bootbox.prompt({
            title: "Enter the desired absolute slope",
            content: "1E-3",
            callback: result => {
                if (result !== null) {
                    var notification = this.userNotifier.showBusyNotification("Updating arrays...");
                    this.modelServices.updateSlopeCfs(modelInfo.name, result)
                        .then(data => {
                            this.userNotifier.clear(notification);
                            //bootbox.alert(data.response, () => { });
                        });

                }
            }
        });

    }

    onShiftTimepointsClick(modelInfo: IModelInfo) {

        MessageBox.prompt({
            title:
                "Shift Model TimePoints ",
            content: "Enter number of timepoints to shift.  This will shift all time-dimensioned data backward (negative value) or forward (positive value)",
            defaultValue: "-1",
            html: true
        })
            .then((result) => {
                if (result !== null) {

                    var payload = {
                        modelId: modelInfo.fullyQualifiedModelId,
                        numberOfTimepoints: Number(result),
                        rootPath: "\\Root"
                    }

                    var notification = this.userNotifier.showBusyNotification("Shifting timepoints...");
                    FetchWrapper.sendCommandAndHandle("/api/1.0/command/shiftModelTimepoints", {
                        method: "post", body: JSON.stringify(payload)
                    })
                        .finally(() => {
                            this.userNotifier.clear(notification);
                            //bootbox.alert(data.response, () => { });
                        });

                }
            })

    }

    onAutoTagModelClick(modelInfo: IModelInfo) {
        this.modelToAutoTagId = modelInfo.name;
        this.showAutoTagModelDialog = true;

    }

    onClearModelTagsClick(modelInfo: IModelInfo) {
        bootbox.confirm("Remove all node tags in model?",
            result => {
                if (result) {
                    var notification = this.userNotifier.showNotification("Clearing tags...", true, true);
                    this.modelServices.clearTags(modelInfo.name)
                        .then(data => {
                            bootbox.alert(data.response, () => { });
                        })
                        .then(() => this.userNotifier.clear(notification));

                }
            });

    }

    onExportModelTagsClicked(modelInfo: IModelInfo) {
        this.userNotifier.showNotification("Building export...", true, false);

        let url = `/api/1.0/nodetags/export/${modelInfo.name}`;
        url = encodeURI(url);
        window.location.href = url;

        return false;

    }

    onImportModelTagsClicked(modelInfo: IModelInfo) {

        this.importModelTagsModelInfo = {
            fileName: "",
            modelId: modelInfo.name
        }

        this.showImportModelTagsDialog = true;
    }

    onModelTagsUploading() {
        this.showImportModelTagsDialog = false;
    }

    onModelTagsUploaded() {
        this.showUploadModelDialog = false;
    }

    onLockModelClicked(modelInfo: IModelInfo) {
        bootbox.confirm("Lock model for editing?",
            result => {
                if (result) {
                    this.directoryServices.lockModel(modelInfo.name)
                        .then(() => this.refreshActiveNodeView());
                }
            });

    }

    onUnlockModelClicked(modelInfo: IModelInfo) {

        bootbox.confirm("Unlock model for editing?",
            result => {
                if (result) {
                    this.directoryServices.unlockModel(modelInfo.name)
                        .then(() => this.refreshActiveNodeView());
                };
            });

    }

    onExecuteModelScriptClicked(modelInfo: IModelInfo) {

        this.executeModelScriptInfo = {
            modelId: modelInfo.name,
            fileName: ""
        };
        this.showExecuteScriptDialog = true;
    }

    onExecutingScript() {
        this.showExecuteScriptDialog = false;
    }

    onExecutedScript() {
        this.showExecuteScriptDialog = false;
    }

    async getTotalScenarioCount(modelIds: string[]): Promise<number> {
        var scenarioCounts = await Promise.all(modelIds.map(async modelId => {

            return await this.modelServices.getScenarioNames(modelId)
                .then(names => {
                    return names.length;
                });
        }));

        return scenarioCounts.reduce((acc, val) => acc + val);

    }



    async pasteNodesFromClipboard(clipboardText: string) {

        const targetNode = this.modelTree.getActiveNode();

        if (targetNode) {

            let targetPath = targetNode.pathAndName;
            // We can't paste to a leaf node
            if (targetNode.nodeType === "DirectoryModel") {
                targetPath = targetNode.path;
            }

            let doPasteNodes = () =>
                this.modelActionsHandler.pasteNodesFromClipboard(targetPath, clipboardText, [])
                    .then(data => {
                        if (data.success)
                            this.refreshActiveNodeView();
                        else
                            bootbox.alertDialog("Paste nodes", data.response);
                    });



            // Check if models have scenarios - if so have to show paste options dialog
            // Only available if pasting one model
            let pasteData: NodeCopyPasteData = JSON.parse(clipboardText);


            // Check if any of the models have scenarios
            if (pasteData.nodeFullPaths.length > 1) {

                var modelIds = pasteData.nodeFullPaths.map(p => {
                    let modelId = p.split("\\").pop();
                    return modelId;
                });

                var totalScenarioCount = await this.getTotalScenarioCount(modelIds);
                if (totalScenarioCount > 0) {
                    bootbox.alert("Cannot copy multiple models with scenarios");
                    return;
                }
                else
                    doPasteNodes();
            }
            else

                if (pasteData.nodeFullPaths.length === 1) {
                    pasteData.nodeFullPaths.forEach(p => {

                        let modelId = p.split("\\").pop();

                        this.modelServices.getScenarioNames(modelId)
                            .then(names => {
                                if (names.length > 0) {
                                    this.pasteNodesOptions = {
                                        // Todo remove these redundant fields or don't use modelInfo here
                                        modelInfo: {
                                            fullyQualifiedModelId: modelId,
                                            category: "",
                                            description: "",
                                            isPinned: false,
                                            logCommands: false,
                                            name: "",
                                            path: p,
                                        },
                                        clipboardText: clipboardText,
                                        selectedScenarioNames: [],
                                        targetPath: targetPath
                                    };
                                    this.showPasteNodesOptionsDialog = true;


                                }
                                else
                                    doPasteNodes();
                            });
                    });
                }

                else
                    doPasteNodes();
        } else
            bootbox.alert("No target tree node selected");
    }

    showPasteNodesOptionsDialogClosed(response: string, pasteData: IPasteNodesOptions) {
        this.showPasteNodesOptionsDialog = false;

        if (response === "ok") {

            // Normalize the scenario names to be node paths
            for (var i = 0; i < pasteData.selectedScenarioNames.length; i++) {
                pasteData.selectedScenarioNames[i] = NodeObject.combinePathAndName(pasteData.modelInfo.path,
                    pasteData.selectedScenarioNames[i]);
            }

            this.modelActionsHandler.pasteNodesFromClipboard(pasteData.targetPath, pasteData.clipboardText,
                pasteData.selectedScenarioNames)
                .then(data => {
                    if (data.success)
                        this.refreshActiveNodeView();
                    else
                        bootbox.alertDialog("Paste nodes", data.response);
                });
        }

    }

    // Tree filter edit key up
    treeFilterInputBoxKeyUp(e) {

        MethodDelayer.delayMethod("treeFilter",
            () => {

                const searchInput = $("#treeFilterInputBox").val();
                if (StringUtils.isText(searchInput)) {
                    this.modelTreeFilter = searchInput;
                    this.populateTree();
                }
            });
    }


    loadAllTreeNodes(): Promise<any> {

        // For this to work all nodes must be present
        if (this.modelTreeIsLazy) {
            this.modelTreeIsLazy = false;
            const nodePathAndName = "\\Models";
            const url = this.getNodesUrlFunc(ModelDirectory.modelId, nodePathAndName);

            var notification = this.userNotifier.showNotification("Loading model directory...", true, true);

            return FetchWrapper.fetch(url, { method: "get" })
                .then(response => response.json())
                .then(data => {
                    this.modelTree.setChildNodes("\\Models", data);

                    // Get the filter text now, because user may have continued typing
                    // while it was loading
                    this.userNotifier.clear(notification);

                });
        } else
            return Promise.resolve();
    }

    handleNodesDeleted(sender: Object, nodes: NodeObject[]) {

        this.modelTree.findNodeByName("RecycleBin")
            .then(node => {
                this.modelTree.refreshNodeChildren(node.pathAndName);
            })
            .catch(() => { })
    }


    onModelPinnedClick(value: IModelInfo, isPinned: boolean) {
        this.modelTree.refreshNodeChildren("\\Models\\Pinned");
    }

    onScenarioCreated(value: IModelInfo, scenarioName: string) {
        this.modelTree.refreshNodeChildren(NodeObject.combinePathAndName(value.path, value.name));

    }
}







// WEBPACK FOOTER //
// ./ClientApp/components/model-directory/model-directory.ts